module.exports = __webpack_public_path__ + "static/theo-manifesto-huh_french-fbd3ec9e23fe4bcd6009ee83de737e8b.gif";